import {
  Component,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { rxState, RxState } from '@rx-angular/state';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RxFor } from '@rx-angular/template/for';
import { leaveAnimation } from '../../animations/leave.animation';

interface Icon {
  name: string;
  shadow?: boolean;
  hover?: boolean;
}

@Component({
  selector: 'lib-icon',
  imports: [RxFor],
  standalone: true,
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  providers: [RxState],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [leaveAnimation]
})
export class IconComponent {

  private state = rxState<{
    svg: SafeHtml[];
    icon: Icon;
  }>();

  readonly svg$ = this.state.select('svg');

  @Input()
  set icon$(icon$: Observable<Icon>) {
    this.state.connect('icon', icon$);
  }

  @Input()
  set name(name: string | undefined) {
    this.state.set((state) => ({
      icon: {
        ...state.icon,
        name: name || ''
      }
    }));
  }

  @Input()
  public set shadow(shadow: boolean | undefined) {
    this.state.set((state) => ({
      icon: {
        ...state.icon,
        shadow: shadow !== undefined ? shadow : false
      }
    }));
  }

  @Input()
  set hover(hover: boolean | undefined) {
    this.state.set((state) => ({
      icon: {
        ...state.icon,
        shadow: hover !== undefined ? hover : false
      }
    }));
  }

  constructor(
    private sanitizer: DomSanitizer,
  ) {
    this.state.connect('svg', this.state.select('icon').pipe(
      map((icon) => {
        const classAttr = `class="svg` +
        ( icon.shadow ? ` svg-shadow` : `` )
          + `"`;
        const classAttrHover = `class="svg icon-hover` +
        ( icon.shadow ? ` svg-shadow` : `` )
        + `"`;
        const hover =  icon.hover ? `
          <svg ${classAttrHover} version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 600 600">
            <use href="#` + icon.name +`" />
          </svg>` : ``;

        const svg =`
          <svg ${classAttr} version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 600 600">
            <use href="#` + icon.name +`" />
          </svg>${hover}`;

        return [this.sanitizer.bypassSecurityTrustHtml(svg)];
      }),
    ));

  }
}
